import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Remove from '../../../SvgIcons/Remove';
import Checkmark from '../../../SvgIcons/Checkmark';
import { HelperText } from '../../form.styles';
import { COLORS } from '../../../../styles/emotion';

interface MessageProps {
  text?: React.ReactNode;
  iconSize?: number;
  className?: string;
  id?: string;
  type: 'success' | 'error';
}

const Container = styled.div`
  display: flex;
`;

const iconStyles = css`
  flex-shrink: 0;
  // Needs to be own block, not inline to text in order to take up entire height when multiline text
  position: relative;
`;

export const StyledRemove = styled(Remove)`
  ${iconStyles};
  color: ${COLORS.SHIRAZ_RED};
  top: 2px;
`;

export const StyledHelperText = styled(HelperText)`
  margin-left: 4px;
`;

const StyledCheckmark = styled(Checkmark)`
  ${iconStyles};
  top: 1px;
  fill: ${COLORS.EVERGREEN};
`;

const Message: React.FC<MessageProps> = ({ type, text, iconSize = 12, className, id }) => (
  <Container className={className} id={id}>
    {type === 'error' ? (
      <StyledRemove width={iconSize} height={iconSize} title="remove-icon" />
    ) : (
      <StyledCheckmark width={iconSize} height={iconSize} title="checkmark-icon" />
    )}
    <StyledHelperText className={className} state={type}>
      {text}
    </StyledHelperText>
  </Container>
);

export default Message;
